module.exports = __webpack_public_path__ + "img/mobile-screen-button.cb13ec3b.svg";